export default __webpack_public_path__ + "static/media/default-profile-pic-feeds.1bd878f2.png";